import { chakra, ChakraProps, FlexProps, forwardRef } from '@chakra-ui/react';

import { useStyles } from './context';

interface DetailSidebarFooterProps extends FlexProps {
  isSticky?: boolean;
}

const DetailSidebarFooter = forwardRef<DetailSidebarFooterProps, 'footer'>(
  ({ isSticky = true, ...props }, ref) => {
    const styles = useStyles();
    const stickyProps = isSticky
      ? ({ bottom: 'space-0', position: 'sticky' } satisfies ChakraProps)
      : {};

    return (
      <chakra.footer
        __css={styles.footer}
        {...stickyProps}
        ref={ref}
        {...props}
      />
    );
  },
);

DetailSidebarFooter.displayName = 'DetailSidebarFooter';

export default DetailSidebarFooter;
